// extracted by mini-css-extract-plugin
export var textInput = "_jt-0";